import {Injectable} from '@angular/core';
import {ApiService} from "../../api.service";

@Injectable({
  providedIn: 'root'
})
export class ApiAdminMajorIncidentTaskService {

  constructor(private apiService: ApiService) {
  }

  listAll(typeId) {
    return this.apiService.get(`/api/admin/type/${typeId}/mitask`);
  }

  get(typeId, id) {
    return this.apiService.get(`/api/admin/type/${typeId}/mitask/${id}`);
  }

  delete(typeId, id) {
    return this.apiService.delete(`/api/admin/type/${typeId}/mitask/${id}`);
  }

  create(typeId, data) {
    return this.apiService.post(`/api/admin/type/${typeId}/mitask`, data);
  }

  update(typeId, id, data) {
    return this.apiService.put(`/api/admin/type/${typeId}/mitask/${id}`, data);
  }

  moveDown(typeId, id) {
    return this.apiService.patch(`/api/admin/type/${typeId}/mitask/${id}/changeorder/down`);
  }

  moveUp(typeId, id) {
    return this.apiService.patch(`/api/admin/type/${typeId}/mitask/${id}/changeorder/up`);
  }


}



